import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router
} from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { SlsService } from './../services/sls.service';
import { MatDialog } from '@angular/material/dialog';
import { AccessDeniedDirectLinkComponent } from 'src/app/shared/modules/components/AccessDeniedDirectLink/AccessDeniedDirectLink';

@Injectable({
  providedIn: 'root'
})
export class ModulesPermissionGuard implements CanActivate {
  constructor(
    private loginService: LoginService,
    private sls: SlsService,
    private dialog: MatDialog,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let permissionKey = next.data['permissionKey'];
    if(permissionKey === 'directory_minimal_permission') {
      permissionKey = 'directory_';
    }

    const loginData = this.sls.get('loginData');

    // ✅ Allow access if subscription_permissions is null, undefined, or empty
    const modulesPermissions = loginData?.subscription_permissions?.modules;
    if (!modulesPermissions || modulesPermissions.length === 0) {
      return true; // Skip guard
    }

    // ✅ Continue normal permission check
    const permissionObj = modulesPermissions.filter(p => p.name.includes(permissionKey));
    //const allowed = permissionObj ? permissionObj.permission === true : true;
    const allowed = permissionObj.some(p => p.permission === true);

    if (!allowed) {
      console.trace("Came to module guard")
      this.dialog.open(AccessDeniedDirectLinkComponent, {
        panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
        backdropClass: 'custom-blur-backdrop',
        disableClose: true,
        width: '30%',
        data: {
          message: `You don't have access to view this module.`,
          showContactAdmin: true
        }
      });

      return false;
    }

    return true;
  }
}